import { useQuery } from "@tanstack/react-query";

import { queries } from "@/api/graphql/constants.ts";
import { LedgersMsSearchGroupsRequestSortField } from "@/api/graphql/types/graphql.ts";

import { searchGroups } from "./api.ts";

export const useSearchGroups = (ids?: string[]) => {
  const response = useQuery({
    queryKey: [queries.GET_SEARCH_GROUPS, { ids }],
    queryFn: async () =>
      await searchGroups({
        filters: ids ? { ids } : undefined,
        paging: {
          page: 1,
          size: 1000,
        },
        sorts: [
          {
            field: LedgersMsSearchGroupsRequestSortField.Code,
            ascending: true,
          },
        ],
      }),
    enabled: true,
  });

  return {
    data: response.data?.LedgersMsSearchGroups.data || [],
    isLoading: response.isLoading,
    pagination: response.data?.LedgersMsSearchGroups.pagination,
  };
};
